export interface Movie {
  id: number;
  title: string;
  category: 'movie' | 'tv' | 'variety';
  subcategory: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  views: number;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
];

export const subcategories: Record<string, string[]> = {
  movie: ['动作', '喜剧', '爱情', '科幻', '恐怖', '剧情', '动画', '纪录片'],
  tv: ['国产剧', '港台剧', '日韩剧', '欧美剧', '网剧'],
  variety: ['真人秀', '脱口秀', '音乐', '竞技', '美食', '旅行'],
};

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20dramatic%20lighting%2C%20dark%20cinematic%20tone%2C%20professional%20film%20poster%20style%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20Chinese%20text%20aesthetic&width=600&height=800&seq=movie-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀，一百年后将吞没地球。人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    duration: '173分钟',
    region: '中国大陆',
    tags: ['科幻', '灾难', '冒险', 'IMAX'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-28更新',
    views: 12560000,
  },
  {
    id: 2,
    title: '封神第二部',
    category: 'movie',
    subcategory: '动作',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20Chinese%20warriors%20in%20elaborate%20armor%2C%20dramatic%20epic%20battle%20scene%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20film%20poster%20aesthetic%2C%20dark%20background%20with%20mythical%20creatures&width=600&height=800&seq=movie-02&orientation=portrait',
    description: '商王殷寿残暴无道，引发天谴。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌。各方势力暗流涌动，风云变幻端倪初显。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰', '娜然'],
    duration: '148分钟',
    region: '中国大陆',
    tags: ['神话', '史诗', '动作', '3D'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-25更新',
    views: 9820000,
  },
  {
    id: 3,
    title: '长安三万里2',
    category: 'movie',
    subcategory: '动画',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20poster%20showing%20ancient%20Chinese%20city%20of%20Changan%20at%20sunset%2C%20poetic%20ink%20painting%20style%2C%20warm%20golden%20and%20vermilion%20colors%2C%20traditional%20Chinese%20aesthetic%2C%20film%20poster%20design&width=600&height=800&seq=movie-03&orientation=portrait',
    description: '安史之乱爆发后数年，吐蕃大军入侵西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事，以及那个群星璀璨的伟大时代。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    duration: '168分钟',
    region: '中国大陆',
    tags: ['动画', '历史', '诗歌', '文艺'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-08-01更新',
    views: 7560000,
  },
  {
    id: 4,
    title: '飞驰人生3',
    category: 'movie',
    subcategory: '喜剧',
    year: 2026,
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20racing%20film%20poster%20with%20race%20car%20on%20track%2C%20dynamic%20action%20shot%2C%20warm%20desert%20colors%2C%20cinematic%20lighting%2C%20professional%20film%20poster%20style%2C%20bright%20and%20vibrant%20tone&width=600&height=800&seq=movie-04&orientation=portrait',
    description: '曾经叱咤风云的拉力赛车手张驰，为养家糊口沦落为驾校教练。机缘巧合下，他接到了一纸组委会的复出邀请。面对新一代天才车手的挑战，张驰决定再次踏上巴音布鲁克的赛道。',
    director: '韩寒',
    actors: ['沈腾', '尹正', '黄景瑜', '刘昊然'],
    duration: '128分钟',
    region: '中国大陆',
    tags: ['喜剧', '赛车', '励志', '动作'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-15更新',
    views: 6540000,
  },
  {
    id: 5,
    title: '深海2',
    category: 'movie',
    subcategory: '动画',
    year: 2026,
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20with%20deep%20ocean%20underwater%20scene%2C%20colorful%20bioluminescent%20creatures%2C%20dreamy%20surreal%20aesthetic%2C%20deep%20blue%20and%20magenta%20color%20palette%2C%20film%20poster%20design&width=600&height=800&seq=movie-05&orientation=portrait',
    description: '在大海的最深处，藏着所有秘密。一位现代少女误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。绚丽到极致的色彩之下，是一场关于孤独与救赎的心灵之旅。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文'],
    duration: '112分钟',
    region: '中国大陆',
    tags: ['动画', '奇幻', '治愈', '冒险'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-08-02更新',
    views: 4320000,
  },
  {
    id: 6,
    title: '异形：夺命舰',
    category: 'movie',
    subcategory: '恐怖',
    year: 2026,
    rating: 7.6,
    image: 'https://readdy.ai/api/search-image?query=Dark%20sci-fi%20horror%20film%20poster%20with%20alien%20xenomorph%20silhouette%20in%20space%20station%20corridor%2C%20atmospheric%20lighting%2C%20cold%20metallic%20tones%2C%20cinematic%20horror%20aesthetic%2C%20professional%20poster%20design&width=600&height=800&seq=movie-06&orientation=portrait',
    description: '一群年轻的太空殖民者在一座废弃的空间站深处进行 scavenging 时，与宇宙中最可怕的生命形态——异形正面相遇。在狭窄密闭的空间站中，无处可逃的他们必须为生存而战。',
    director: '费德·阿尔瓦雷兹',
    actors: ['卡莉·史派妮', '伊莎贝拉·默塞德'],
    duration: '119分钟',
    region: '美国',
    tags: ['科幻', '恐怖', '惊悚', '好莱坞'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-08-03更新',
    views: 8760000,
  },
  {
    id: 7,
    title: '庆余年第二季',
    category: 'tv',
    subcategory: '国产剧',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20ancient%20Chinese%20palace%20setting%2C%20elegant%20traditional%20costumes%2C%20warm%20golden%20and%20crimson%20tones%2C%20TV%20series%20poster%20aesthetic%2C%20dramatic%20lighting&width=600&height=800&seq=tv-01&orientation=portrait',
    description: '范闲在经历了生死考验后，更加坚定了自己的信念。北齐之行归来后，他在庆国的权力斗争中逐渐成长。面对更加复杂的朝堂局势和暗流涌动的阴谋，范闲将如何运用自己的智慧与勇气，守护所爱之人？',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟', '田雨'],
    duration: '36集',
    region: '中国大陆',
    tags: ['古装', '权谋', '剧情', '热门'],
    isHot: true,
    isNew: false,
    updateInfo: '更新至28集',
    views: 25800000,
  },
  {
    id: 8,
    title: '大奉打更人',
    category: 'tv',
    subcategory: '国产剧',
    year: 2026,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20detective%20drama%20poster%20with%20ancient%20Chinese%20night%20watchman%20in%20mysterious%20setting%2C%20dark%20atmospheric%20tone%2C%20warm%20lantern%20light%2C%20TV%20drama%20poster%20design&width=600&height=800&seq=tv-02&orientation=portrait',
    description: '现代警校毕业的许七安穿越到大奉王朝，成为一名打更人（古代警察）。在这个妖魔横行、案件频发的世界，他凭借现代刑侦知识屡破奇案，同时也逐渐揭开了大奉王朝背后的惊天秘密。',
    director: '邓科',
    actors: ['王鹤棣', '田曦薇', '刘奕君', '晏紫东'],
    duration: '40集',
    region: '中国大陆',
    tags: ['古装', '奇幻', '探案', '穿越'],
    isHot: true,
    isNew: false,
    updateInfo: '更新至32集',
    views: 19800000,
  },
  {
    id: 9,
    title: '鱿鱼游戏第二季',
    category: 'tv',
    subcategory: '日韩剧',
    year: 2026,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%20with%20geometric%20shapes%20and%20guards%20in%20pink%20uniforms%2C%20dark%20mysterious%20atmosphere%2C%20neon%20pink%20and%20dark%20green%20color%20scheme%2C%20Netflix%20style%20poster%20design&width=600&height=800&seq=tv-03&orientation=portrait',
    description: '成奇勋在赢得游戏后，原本打算前往美国与女儿团聚，却在机场发现了游戏的蛛丝马迹。带着复仇的决心和揭开真相的使命，他决定重返这场死亡游戏的漩涡之中。',
    director: '黄东赫',
    actors: ['李政宰', '李秉宪', '魏嘏隽', '孔刘'],
    duration: '7集',
    region: '韩国',
    tags: ['悬疑', '惊悚', '剧情', 'Netflix'],
    isHot: true,
    isNew: true,
    updateInfo: '全7集已完结',
    views: 35200000,
  },
  {
    id: 10,
    title: '繁花',
    category: 'tv',
    subcategory: '国产剧',
    year: 2026,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20set%20in%201990s%20Shanghai%2C%20nostalgic%20neon%20cityscape%2C%20elegant%20retro%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20TV%20series%20poster%20design%2C%20glamorous%20urban%20feel&width=600&height=800&seq=tv-04&orientation=portrait',
    description: '九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧和改革开放的春风，从默默无闻的小人物一跃成为上海滩的风云人物。在时代的洪流中，人人争做弄潮儿，谱写了一段段关于梦想、爱情与奋斗的故事。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    duration: '30集',
    region: '中国大陆',
    tags: ['年代', '商战', '剧情', '经典'],
    isHot: false,
    isNew: false,
    updateInfo: '全30集已完结',
    views: 18200000,
  },
  {
    id: 11,
    title: '龙之家族第二季',
    category: 'tv',
    subcategory: '欧美剧',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20drama%20poster%20with%20dragon%20silhouette%20and%20medieval%20castle%2C%20epic%20dark%20fantasy%20aesthetic%2C%2C%20HBO%20style%20poster%20design%2C%20dramatic%20lighting&width=600&height=800&seq=tv-05&orientation=portrait',
    description: '坦格利安家族的内战——"血龙狂舞"正式爆发。雷妮拉·坦格利安与阿莉森·海塔尔各据一方，龙与龙之间的对决将维斯特洛大陆拖入了一场毁灭性的战争。家族、忠诚与背叛，在这场权力游戏中无人能够独善其身。',
    director: '阿兰·泰勒',
    actors: ['艾玛·达西', '马特·史密斯', '奥利维亚·库克'],
    duration: '8集',
    region: '美国',
    tags: ['奇幻', '史诗', '剧情', 'HBO'],
    isHot: false,
    isNew: true,
    updateInfo: '更新至4集',
    views: 12400000,
  },
  {
    id: 12,
    title: '乘风破浪的姐姐5',
    category: 'variety',
    subcategory: '真人秀',
    year: 2026,
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20female%20celebrities%20on%20stage%2C%20glamorous%20performance%20aesthetic%2C%20vibrant%20pink%20and%20gold%20color%20scheme%2C%20reality%20show%20poster%20design%2C%20bright%20stage%20lighting&width=600&height=800&seq=var-01&orientation=portrait',
    description: '30位30+的姐姐再度集结，开启全新的舞台竞演之旅。她们来自演艺圈的不同领域，有的是歌手，有的是演员，有的是主持人。在这个舞台上，姐姐们突破自我，用汗水和才华诠释女性力量。',
    director: '芒果TV',
    actors: ['宁静', '那英', '张雨绮', '万茜'],
    duration: '12期',
    region: '中国大陆',
    tags: ['真人秀', '音乐', '竞演', '女性'],
    isHot: true,
    isNew: false,
    updateInfo: '更新至第8期',
    views: 15200000,
  },
  {
    id: 13,
    title: '脱口秀大会6',
    category: 'variety',
    subcategory: '脱口秀',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20stand-up%20comedy%20show%20poster%20with%20comedian%20on%20stage%20with%20microphone%2C%20modern%20urban%20aesthetic%2C%20warm%20spotlight%20effect%2C%20entertaining%20poster%20design%2C%20dark%20background%20with%20colorful%20accents&width=600&height=800&seq=var-02&orientation=portrait',
    description: '新一季脱口秀大会再度回归！来自各行各业的脱口秀演员们用幽默犀利的语言，讲述生活中的酸甜苦辣。领笑员阵容全面升级，更有神秘大咖惊喜加盟。笑料不断，金句频出。',
    director: '腾讯视频',
    actors: ['李诞', '王建国', '庞博', '呼兰', '杨笠'],
    duration: '10期',
    region: '中国大陆',
    tags: ['脱口秀', '喜剧', '综艺', '语言'],
    isHot: false,
    isNew: true,
    updateInfo: '更新至第5期',
    views: 11200000,
  },
  {
    id: 14,
    title: '密室大逃脱5',
    category: 'variety',
    subcategory: '竞技',
    year: 2026,
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20escape%20room%20reality%20show%20poster%20with%20mysterious%20room%20setting%2C%20puzzle%20elements%2C%20suspenseful%20atmosphere%2C%20warm%20orange%20and%20deep%20shadow%20color%20scheme%2C%20variety%20show%20poster%20design&width=600&height=800&seq=var-03&orientation=portrait',
    description: '明星嘉宾们被困在精心设计的大型密室中，需要通过解谜、寻找线索、团队协作才能逃出生天。本季场景全面升级，关卡更加烧脑刺激，更有全新嘉宾阵容带来不一样的化学反应。',
    director: '芒果TV',
    actors: ['杨幂', '大张伟', '黄明昊', '张国伟'],
    duration: '12期',
    region: '中国大陆',
    tags: ['真人秀', '解谜', '烧脑', '冒险'],
    isHot: false,
    isNew: false,
    updateInfo: '更新至第10期',
    views: 8900000,
  },
  {
    id: 15,
    title: '狂飙2',
    category: 'tv',
    subcategory: '国产剧',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20police%20officer%20and%20criminal%20confrontation%2C%20dark%20serious%20tone%2C%20urban%20night%20setting%2C%20dramatic%20lighting%2C%20TV%20drama%20poster%20design&width=600&height=800&seq=tv-06&orientation=portrait',
    description: '故事延续前作，扫黑除恶专项斗争进入深水区。新一代刑警面临更加隐蔽的犯罪网络，一场关于正义与邪恶的较量在暗处悄然展开。每一个抉择都可能改变无数人的命运。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '吴刚'],
    duration: '40集',
    region: '中国大陆',
    tags: ['犯罪', '悬疑', '剧情', '热播'],
    isHot: true,
    isNew: true,
    updateInfo: '更新至18集',
    views: 32100000,
  },
  {
    id: 16,
    title: '速度与激情11',
    category: 'movie',
    subcategory: '动作',
    year: 2026,
    rating: 7.5,
    image: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20fast%20cars%20in%20urban%20street%20chase%2C%20explosive%20dynamic%20action%2C%20warm%20orange%20sunset%20lighting%2C%20blockbuster%20film%20poster%20design%2C%20cinematic%20aesthetic&width=600&height=800&seq=movie-07&orientation=portrait',
    description: '唐老大和他的家人们再次回归，面对前所未有的全球性威胁。从罗马到里约，从东京到洛杉矶，速度与激情家族将在全球范围内展开一场惊心动魄的终极冒险。',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·斯坦森', '米歇尔·罗德里格兹'],
    duration: '142分钟',
    region: '美国',
    tags: ['动作', '赛车', '冒险', '好莱坞'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-08-02更新',
    views: 10800000,
  },
];

export const getMoviesByCategory = (category: string): Movie[] => {
  return movies.filter((m) => m.category === category);
};

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter((m) => m.isNew);
};

export const getRelatedMovies = (movie: Movie, count: number = 6): Movie[] => {
  return movies
    .filter((m) => m.id !== movie.id && (m.category === movie.category || m.subcategory === movie.subcategory))
    .slice(0, count);
};